import MobileMenu from "./components/MobileMenu";
import Viewport from "./components/Viewport";
import { useState } from "react";
import { Link } from "react-router-dom";
import { AiOutlineMenu } from "react-icons/ai";

import graphownblock from "../images/Graphic-Owned-Block-p-800.png";
import graphowncoins from "../images/Graphic-Owned-Coins-p-500.png";
import graphownplanets from "../images/Graphic-Owned-Planets-p-500.png";
import { IoLogInOutline } from "react-icons/io5";
import PageFooter from "./components/PageFooter";

const About = () => {
  const { width } = Viewport();

  const [inactiveMobileNav, activeMobileNav] = useState(false);

  const breakpoint = 558;

  return (
    <div className="absolute overflow-x-hidden min-h-full w-full bg-mainBackColor">
      <div className="relative overflow-hidden min-h-full flex flex-col justify-start items-center text-white w-full p-[1rem]">
        {/* mobile menu */}
        <MobileMenu
          closeMobileMenu={() => {
            activeMobileNav(false);
          }}
          translateAction={
            !inactiveMobileNav ? `translate-y-[-1500px]` : `translate-y-[0px]`
          }
        />

        {/* nav section */}
        {
          <nav className="relative flex justify-between items-center min-h-[4rem] w-full md:w-[80%]">
            <Link
              to="/"
              className="relative flex justify-start items-center h-full"
            >
              <span className="font-logo font-[700] text-[18px] tracking-tight text-white">Zenit<span className="text-userDashPurple">chain</span></span>
            </Link>

            {width < breakpoint ? (
              <button className="flex" onClick={() => activeMobileNav(true)}>
                <AiOutlineMenu className="text-white font-[500] text-[24px]" />
              </button>
            ) : (
              ""
            )}

            <div className="hidden justify-between items-center sm:flex">
              <ul className="flex space-x-10">
                <li className="text-white font-[500] text-[15.5px]">
                  {" "}
                  <Link to="/Signin">Trade</Link>{" "}
                </li>
                <li className="text-white font-[500] text-[15.5px]">
                  {" "}
                  <Link to="/about">About</Link>{" "}
                </li>
                <li className="text-white font-[500] text-[15.5px]">
                  {" "}
                  <Link to="/airdrops">Airdrops</Link>{" "}
                </li>
              </ul>
            </div>

            <Link
              to="/signin"
              className="relative w-[110px] h-[38px] hidden justify-center items-center border border-primaryGreen rounded space-x-2 sm:flex transition-all hover:bg-primaryGreen/10"
            >
              <IoLogInOutline className="text-primaryGreen text-[16.5px] font-[500] " />
              <p className=" text-[14.5px] text-primaryGreen">Sign in </p>
            </Link>
          </nav>
        }

        {/* about us */}
        <div className="relative w-full min-h-[8rem] py-[6rem] flex flex-col justify-center items-center space-y-[9rem] md:w-[90%] lx:w-[85%]">
          <div className="relative w-full min-h-[14rem] flex flex-col space-y-[4rem] justify-center items-center lg:space-y-[0rem] lg:flex-row lg:justify-between lg:items-center">
            {/* text */}
            <div className="relative w-full flex flex-col items-center space-y-8 lg:w-[50%]">
              <div className="relative flex flex-col items-start space-y-5 lg:max-w-[500px]">
                <h2 className="font-[550] text-[28px] text-white">
                  Built on web3. Owned by you.
                </h2>
                <p className="text-[#ACACB5] text-[16px] tracking-wide">
                  Welcome to Zenitchain, your trusted partner in the world of
                  cryptocurrency trading. At Zenitchain, we are passionate about
                  the transformative power of digital currencies and their
                  potential to reshape the global financial landscape. As a
                  leading cryptocurrency trading company, we strive to provide
                  our clients with seamless access to the exciting and dynamic
                  cryptocurrency markets. Our team of experienced traders,
                  blockchain experts, and financial analysts work diligently to
                  deliver cutting-edge trading solutions and valuable insights
                  to our clients. Whether you are a seasoned investor or just
                  starting your cryptocurrency journey, we are here to guide you
                  every step of the way.
                </p>
              </div>
            </div>

            {/* image */}
            <div className="relative w-full flex justify-center items-center min-h-[300px] lg:w-[50%]">
              <img
                src={graphownblock}
                alt="graphbox"
                loading="lazy"
                className="absolute top-0 left-[1/2] w-[356px] h-[356px] lg:w-[400px] lg:h-[350px]  "
              />
              <img
                src={graphownplanets}
                alt="graphbase"
                loading="lazy"
                className="absolute top-0 left-[1/2] w-[356px] h-[356px] lg:w-[400px] lg:h-[350px]  "
              />
              <img
                src={graphowncoins}
                alt="graphorbital"
                loading="lazy"
                className="absolute top-0 left-[1/2] w-[356px] h-[356px] lg:w-[400px] lg:h-[350px] "
              />
            </div>
          </div>
        </div>

        <PageFooter />
      </div>
    </div>
  );
};

export default About;
